<template>
  <div class="cell">
    <div class="card flex" :class="[(isExp || item.disabled)?'card-exp':'card-default']">
      <div class="left flex">
        <div class="ll" v-if="!isExp">
          <van-radio :name="item.couponId" @click="radioClick" v-if="isRadio" :disabled="item.disabled">
            <template v-if="!item.disabled" #icon="props">
              <img class="img-16" :src="props.checked?require('@/assets/coupon-imgs/xuanzhong.png'):require('@/assets/coupon-imgs/weixuanzhong.png')" alt="">
            </template>
          </van-radio>
        </div>
        <!-- message box -->
        <div class="flex flex-col flex-col-center h100 flex-row-end">
          <div class="big">
            {{ item.name }}
          </div>
          <div class="l"></div>
          <div class="w-183 small color0-46">有效期：{{ expireDate }}</div>
          <div class="w-183 h-20 progress flex flex-col flex-row-center"
          v-if="(!isGet || (isGet && !isUse)) && !isExp && !isRadio">
            <div
              v-if="isGet && !isUse && showUse"
              class="is-get flex flex-row flex-col-center flex-self-center"
              @click="onUseFn(item)"
            >
              <span class="line-16">立即使用</span>
              <!-- <img src="@/assets/coupon-imgs/jinru.png" alt="" /> -->
              <van-icon
                name="Doublearrowright"
                class-prefix="hsyfont"
                size="0.42667rem"
                color="rgba(0,0,0,.46)"
              />
            </div>
            <span v-if="!isGet" class="no-get"
              >剩余：{{ percent }}%</span
            >
            <van-progress
              v-if="!isGet"
              color="#f2826a"
              :percentage="percent"
              :show-pivot="false"
            />
          </div>
          <div class="line">
            <van-divider dashed style="margin: 0.10667rem 0" />
          </div>
          <div
            class="w-183 flex flex-between last color0-46"
            @click.stop="showRule(item)"
          >
            <div>使用规则</div>
            <div>
              <van-icon
                :name="showRuleDiv ? 'arrow-up' : 'arrow-down'"
                size="0.42667rem"
                color="rgba(0,0,0,.46)"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 已使用 -->
      <img src="@/assets/coupon-imgs/ysy.png" alt="" class="img-68" v-if="isGet && isUse && !isExp">
      <!-- 已过期 -->
      <img src="@/assets/coupon-imgs/ygq.png" alt="" class="img-68" v-if="isExp">
      <div class="right flex flex-col flex-col-center" :class="[(!isExp && !isRadio && !isUse)?'flex-between':'flex-row-center']">
        <div class="big" :class="[item.subPrice.toString().length>3?'font-30':'font-40']">{{ item.subPrice }}</div>
        <div class="m-5 font-12">满{{ item.fullPrice }}可用</div>
        <template v-if="!isExp && !isRadio && !isUse">
          <template v-if="!isGet">
            <div class="btn shadow font-12" @click="onGetFn(item)" v-if="!isGet">
              立即领取
            </div>
          </template>
          <div class="btn shadow font-12" v-else>已领取</div>
        </template>
      </div>
    </div>
    <div class="rule-div" v-if="showRuleDiv">
      <div class="rule-div-child color0-46">
        {{ item.ruleMemo || '暂无规则说明'}}
      </div>
    </div>
    <div class="newer-tag" v-if="item.couponType == '1' && !isExp">
      <img src="@/assets/coupon-imgs/newer-full.png" alt="">
    </div>
  </div>
</template>
<script>
/**
 * @description 优惠券组件
 * @param {String|Number} couponInfoId 优惠券id
 * @param {String} name 优惠券名称
 * @param {String|Number} couponType 券类型：1.新人专享券 ，2.现金优惠
 * @param {String|Number} ruleScope 优惠券类型：1.不限（全场通用），2.部分商品不参加，3.只部分商品参加 （作废）
 * @param {Date} startTime 有效期开始时间
 * @param {Date} endTime 有效期结束时间
 * @param {Number} progress 领取进度 百分比（已领取数量/总发放数量）
 * @param {Number} fullPrice 金额满
 * @param {Number} subPrice 金额减
 * @param {Number|String} grantState 领取状态 0.可领，1.已领取，2.作废
 * @param {Number|String} useState 使用状态：1.未使用 ，2.已使用，3.已过期
 * @param {Number} sumCount 券总数量
 * @param {Number} sentCount 已领取数量
 * @param {Number} limitCount 限领数量
 * @param {String} ruleMemo 规则
 * @param {Boolean} disabled 是否禁用radio
 */
export default {
  name: "couponItem",
  data() {
    return {
      showRuleDiv:false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isRadio:{
      type:Boolean,
      default:false
    },
    radioValue:{
      default:''
    },
    showUse:{
      type:Boolean,
      default:true
    }
  },
  computed:{
    /**
     * @description 是否过期
     */
    isExp(){
      return this.item.useState==3 && this.item.useState !== null
    },
    /**
     * @description 是否已领取
     */
    isGet(){
      return this.item.grantState == 1 || this.item.grantState === null
    },
    /**
     * @description 是否使用
     */
    isUse(){
      return this.item.grantState == 1 && this.item.useState == 2
    },
    /**
     * @description 剩余百分比
     */
    percent(){
      return parseInt(100-this.item.progress) || 0
    },
    /**
     * @description 过期时间
     */
    expireDate(){
      return this.$moment(this.item.startTime).format('YYYY-MM-DD') + '-' +
        this.$moment(this.item.endTime).format('YYYY-MM-DD')
    }
  },
  created(){
    // console.log(this.$moment(this.item.startTime).format('YYYY-MM-DD HH:mm:ss'))
  },
  methods: {
    onGetFn: function () {
      this.$emit("onGet", this.item.couponInfoId);
    },
    onUseFn: function () {
      this.$emit("onUse", this.item.couponInfoId);
    },
    showRule: function () {
      this.showRuleDiv = !this.showRuleDiv;
    },
    radioClick:function(){
      // console.log(this.radioValue,this.item.couponId,'radioClick')
      if(this.item.disabled) return
      this.$emit('check',this.item.couponId)
      // if(this.radioValue == this.item.couponId) this.$emit('check',this.item.couponId)
    }
  },
};
</script>
<style lang="less">
.h-20 {
  height: 20px;
}
.font-14 {
  font-size: 14px;
}
.font-12 {
  font-size: 12px !important;
}
.font-10{
  font-size: 10px !important;
}
.font-40{
  font-size: 40px !important;
}
.font-30{
  font-size: 30px !important;
}
.line-16{
  line-height: 16px;
}
.color0-46{
  background: #FFFFFF;
  color: rgba(0, 0, 0, 0.46);
}
.img-16{
  width: 16px;
  height: 16px;
  object-fit: fill;
}
.img-68{
  width:48px;
  height:48px;
  position: absolute;
  top: 22px;
  right: 102px;
  transform: rotate(-45deg);
}
.m-5{
  // width: 100%;
  white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
}
.card {
  margin: 0 10px;
  // width: 355px;
  &.card-default{
    background: url(../assets/coupon-imgs/youhuiquan.png) no-repeat;
    height: 105px;
    background-size: 100% 100%;
  }
  
  .left,
  .right {
    height: 100%;
    div {
      color: rbga(0, 0, 0, 0.68);
    }
  }
  .left {
    align-items: center;
    padding: 5px;
    flex: 1;
    .ll{
      padding-left: 14px;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .big {
      color: rgba(0, 0, 0, 0.68);
      font-size: 24px;
      line-height: 33px;
    }
    .small {
      font-size: 10px;
      line-height: 14px;
      height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .w-183 {
      width: 183px;
    }
    .line {
      width: 229px;
    }
    .last {
      line-height: 14px;
      font-size: 10px;
    }
    .progress {
      height: 20px;
      color: #fa6339;
      .no-get {
        font-size: 12px;
        line-height: 17px;
      }
      .is-get {
        height: 20px;
        span {
          font-size: 14px;
        }
      }
    }
  }
  .right {
    padding: 6px 12px 6px;
    color: #ffffff;
    width: 87px;
    .big {
      font-size: 40px;
      // line-height: 56px;
    }
    .btn {
      width: 69px;
      height: 22px;
      line-height: 20px;
      color: #fa6339;
      background: #ffffff;
      border-radius: 11px;
      text-align: center;
    }
  }
  &.card-exp{
    background: url(../assets/coupon-imgs/youhuiquan-guoqi.png) no-repeat;
    height: 105px;
    background-size: 355px 100%;
    .big,.left{
      color: rgba(0, 0, 0, 0.3) !important;
      div{
        color: rgba(0, 0, 0, 0.3) !important;
      }
    }
    .right{
      .big{
        color: #FFFFFF !important;
      }
    }
  }
}
.cell {
  position: relative;
  padding-top: 10px;
  .rule-div {
    margin: 0 10px;
    // padding: 12px;
    padding-top: 4px;
    min-height: 48px;
    border-radius: 0 0 6px 6px;
    border: 1px solid rgba(250, 99, 57, 0.37);
    border-top: 0;
    margin-top: -4px;
    font-size: 10px;
    line-height: 14px;
    &-child{
      padding: 12px;
      min-height: 44px;
      border-radius: 0 0 6px 6px;
    }
  }
  .newer-tag{
    position: absolute;
    z-index: 9;
    width: 69px;
    height: 18px;
    left: 11px;
    top: 7px;
    img{
      width: 69px;
      height: 18px;
    }
  }
}

</style>